export const BACKUP_POLICY_ID_PROPERTY = 'backupPolicyId';
export const BACKUP_STATUS_PROPERTY = 'backupStatus';
export const CLOUD_PROVIDER_PROPERTY = 'cloudProvider';
export const COMPLIANCE_STATUS_PROPERTY = 'complianceStatus';
export const CONFIGURATION_STATUS_PROPERTY = 'configurationStatus';
export const CONTROL_ID_PROPERTY = 'controls';
export const CONTROL_LEVEL_PROPERTY = 'severity';
export const HAS_DLSG_POLICY_PROPERTY = 'hasDlsgPolicy';
export const MUTED_CONTROL_ID_PROPERTY = 'mutedControls';
export const RESOURCE_ID_PROPERTY = 'resourceId';
export const RESOURCE_NAME_PROPERTY = 'resourceName';
export const RESOURCE_TYPE_PROPERTY = 'resourceType';
export const SECURITY_SCAN_CONCLUSION_PROPERTY = 'securityScanConclusion';
export const SOURCE_ACCOUNT_ID_PROPERTY = 'sourceAccountId';
export const VAULT_ID_PROPERTY = 'vaultId';
